import script from "./installed-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./installed-detail.vue?vue&type=script&setup=true&lang=ts"

import "./installed-detail.vue?vue&type=style&index=0&id=7a919ab4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a919ab4"]])

export default __exports__